import { RESET_DATASET } from 'store';

import { SET_NULL_VALUE } from './types';

import { RESET_RANDOMIZATION_HYPOTHESIS_TESTING } from '../types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_NULL_VALUE:
      return action.nullValue;
    case RESET_DATASET:
    case RESET_RANDOMIZATION_HYPOTHESIS_TESTING:
      return null;
    default:
      return state;
  }
};
